
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[event]/register",
      function () {
        return require("private-next-pages/[event]/register.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[event]/register"])
      });
    }
  